<div
  (clickOutSide)="close()"
  [ngClass]="extraClass ? extraClass : ''"
  [class.show]="isOpen"
  id="search-utility-bar-dropdown"
  class="dropdown"
  appClickOutside>
  <button (click)="toggle()"
          [class.search-utility-bar-selected]="getSelectedItem()"
          [attr.aria-expanded]="isOpen"
          id="search-utility-bar-dropdown-label"
          class="ni-btn ni-btn-search"
          type="button"
          aria-haspopup="true">
    <span class="search-utility-dropdown-text" [innerText]="getText()"></span>
    <span class="search-utility-bar-dropdown-svg">
      <svg-icon key="dropdown-down" width="14px" height="4px"></svg-icon>
    </span>
  </button>
  <ul
    *ngIf="isOpen"
    class="dropdown-menu search-utility-bar-dropdown-menu"
    [class.show]="isOpen"
    aria-labelledby="search-utility-bar-dropdown-label">
    <span class="search-utility-dropdown-text-2" [innerText]="defaultText"></span>
    <li *ngFor="let item of items"
        [class.active]="item.isSelected"
        class="dropdown-item">
      <a (click)="onClickItem(item.value)"
         [innerText]="item.displayText"></a>
    </li>
  </ul>
</div>
